export const filteredData = <T extends { id: number }>(
  data: T[],
  excludedItem: T[]
) => {
  return data.filter((item) => {
    const match = excludedItem.find((copy) => copy.id === item.id)
    return !match
  })
}
